import AboutHero from '../components/AboutHero';

function About() {
  return (
    <main>
      <AboutHero />
      <div className='about-page container-large'>
        <section className='about-panel'>
          <div className='about-panel__header'>
            <p className='about-panel__eyebrow'>Biography</p>
            <h2>About Schuyler</h2>
            <p className='about-panel__intro'>
              A career in journalism, public affairs, and publishing shaped a
              voice grounded in clarity, lived experience, and faith.
            </p>
          </div>
          <div className='about-panel__grid'>
            <div className='about-panel__portrait'>
              <div className='about-panel__portrait-frame'>
                <img
                  src={process.env.PUBLIC_URL + '/images/sky-portrait.webp'}
                  alt='Portrait of Schuyler Sprowles'
                />
              </div>
            </div>
            <div className='about-panel__bio'>
              <p className='animate-text'>
                Schuyler Sprowles began his career in radio as a country music
                personality and news reporter for numerous stations, ultimately
                becoming a television news anchor in Dallas, Texas. In time,
                Schuyler moved to Los Angeles, where he worked as a TV news
                correspondent. That path eventually led into a high-profile
                public affairs career, serving as Communications Director for
                major Los Angeles public agencies, including the City Attorney,
                District Attorney, and Department of Children and Family
                Services.
              </p>
              <p className='animate-text'>
                After years in crisis management and speech writing, Schuyler
                turned to publishing, founding a family-oriented magazine that
                remains in circulation today. A lifelong Christian, he admits
                to walking away from his faith at times, only to discover Jesus
                waiting in the shadows to guide him back where he belongs. His
                debut novel is shaped by that long personal and professional
                journey, and draws directly from the world of the Gospels.
              </p>
              <div className='about-panel__highlights'>
                <div className='about-panel__highlight'>
                  <span className='about-panel__highlight-label'>
                    Background
                  </span>
                  <span>Broadcast journalism</span>
                </div>
                <div className='about-panel__highlight'>
                  <span className='about-panel__highlight-label'>Work</span>
                  <span>Public affairs and publishing</span>
                </div>
                <div className='about-panel__highlight'>
                  <span className='about-panel__highlight-label'>Writing</span>
                  <span>Fiction inspired by the Gospels</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default About;
